// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2m2Dr","info":"Note_info__2DHXd","note":"Note_note__fkuRL","actions":"Note_actions__8xuBW"};